import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const volumeDifference = (tj: Partial<TherapyJobV2>): number => {
  const totalVolume = tj?.totalVolumeEdited || tj?.totalVolumePrescribed;
  const injectedVolume = tj?.therapyJobProgress?.injectedVolume || 0;

  if (!totalVolume) {
    return 0;
  }

  return injectedVolume - totalVolume;
};
